import React from 'react';
import './Banner.css';

const Banner = () => {
  
    return (
        <div>
            <div className="banner">
                <div className="image">
                    <img src="https://i.ibb.co/z5h61J7/1a-bmw-wanchaishowroom-finedata-1.png" alt="" />
                </div>
                <div className="details">
                    <h1>The New Comfort Zone </h1>
                    <h1>Unveiling Soon.</h1>
                    <p>The new C-Class.</p>
                </div>

            </div>
        </div>
    );
};

export default Banner;